export function isUnsupportedBrowser(): boolean {
  return (
    /CriOS/.test(navigator.userAgent) || // Chrome on iOS
    navigator.appName === 'Microsoft Internet Explorer' ||
    (navigator.appName === 'Netscape' && (navigator.userAgent.includes('.NET') || /\WEdg\//.test(navigator.userAgent)))
  );
}
